/**
 * Forgot Password Page - ViTex
 */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { authAPI } from '../services/api';
import { useI18n } from '../i18n/I18nContext';
import Footer from '../components/Footer';
import Logo from '../components/Logo';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await authAPI.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.message || t('auth.forgot.somethingWrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <Logo height={40} />
          </div>

          <h1>{t('auth.forgot.title')}</h1>
          <p className="auth-subtitle">{t('auth.forgot.subtitle')}</p>

          {error && <div className="error-message">{error}</div>}

          {submitted ? (
              <div className="success-message" style={{ marginTop: 16 }}>
                {t('auth.forgot.ifAccountExists', { email })}
              </div>
          ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">{t('auth.fields.email')}</label>
                  <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder={t('auth.fields.emailPlaceholder')}
                  />
                </div>

                <button
                    type="submit"
                    className="btn-primary-auth"
                    disabled={loading}
                >
                  {loading ? t('auth.forgot.sending') : (
                      <>
                        <Mail size={20} /> {t('auth.forgot.sendLink')}
                      </>
                  )}
                </button>
              </form>
          )}

          <p className="auth-footer">
            {t('auth.forgot.remembered')} <Link to="/login">{t('auth.forgot.backToSignIn')}</Link>
          </p>

          <Link to="/" className="back-home">
            {t('common.backToHome')}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
